function onConsent(preference) {
    console.log('onConsent', preference);
    setTimeout(function () {
        if (preference.consent) {
            dataLayer.push({
                'event': 'cookie_law_accepted',
                'consense_marketing': true,
                'anonymizeIp': true
            });
        } else if (preference.purposes) {
            if (preference.purposes[5]) {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': true,
                    'anonymizeIp': false
                });
            } else if (preference.purposes[4]) {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': false,
                    'anonymizeIp': false
                });
            } else {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': false,
                    'anonymizeIp': true
                });
            }

        }
    }, 500);
}

function onConsentFirstGiven(preference) {
    console.log('onConsentFirstGiven', preference);
}

function onConsentGiven(preference) {
    console.log('onConsentGiven', preference);
}

var _iub = _iub || [];
_iub.csConfiguration = {
    "whitelabel": false,
    "lang": locale,
    "floatingPreferencesButtonDisplay": "bottom-left",
    "siteId": iubendaSiteId,
    "consentOnContinuedBrowsing": false,
    "perPurposeConsent": true,
    "cookiePolicyId": iubendaPolicy,
    "callback": {
        "onPreferenceFirstExpressed": function(event) {
            onConsent(event);
        }
    },
    "banner": {
        "acceptButtonDisplay": true,
        "acceptButtonCaption":translation__cookiebar__accept_all,
        "acceptButtonColor":"#395d22",
        "rejectButtonDisplay":true,
        "rejectButtonCaption":translation__cookiebar__reject_all,
        "rejectButtonColor":"#4c4c4c",
        "customizeButtonDisplay": true,
        "position": "float-center",
        "content": translation__cookiebar__text,
    },
    "cookiePolicyUrl": url__cookie_policy
};